"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _CreateWorker = _interopRequireDefault(require("./CreateWorker"));

var _worker = _interopRequireDefault(require("./worker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var workingWorker = new _CreateWorker["default"](_worker["default"]);

var useStopWatch = function useStopWatch() {
  var cleanTimer = {
    seconds: 0,
    minutes: 0,
    hours: 0,
    complete: '00:00:00'
  };

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      enabled = _useState2[0],
      setEnabled = _useState2[1];

  var _useState3 = (0, _react.useState)(cleanTimer),
      _useState4 = _slicedToArray(_useState3, 2),
      timer = _useState4[0],
      setTimer = _useState4[1];

  workingWorker.addEventListener('message', function (_ref) {
    var data = _ref.data;
    setTimer(data);
  });

  var startTimer = function startTimer() {
    if (!enabled) {
      workingWorker = new _CreateWorker["default"](_worker["default"]);
      workingWorker.postMessage('start');
      setEnabled(true);
    }
  };

  var stopTimer = function stopTimer() {
    workingWorker.terminate();
    setTimer(cleanTimer);
    setEnabled(false);
  };

  return {
    seconds: timer.seconds,
    minutes: timer.minutes,
    hours: timer.hours,
    fullFormat: timer.complete,
    start: startTimer,
    stop: stopTimer
  };
};

var _default = useStopWatch;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/StopWatch/Worker/useStopWatch.js
// module id = 1922
// module chunks = 0